import React from 'react'
const ThowColumLayoutDashboard = ({colum1,colum2,background,page,name,height}) => {

    const container = {
        "background":"background",
        "display":"grid",
        "height":"auto",
        "gridTemplateColumns": "229px 1fr "
    }

    const colum1Layout = {
        gridColumnStart: '1',
        gridColumnEnd: '2',
    }

    const colum2Layout = {
        gridColumnStart: '2',
        gridColumnEnd: '2',
        
    }
    


    return(
        
        <>

        <div className='thow_colum_layout_dashboard'>
        <div style={colum1Layout}>
     
        {colum1}
        </div>

        <div  style={colum2Layout}>
        {colum2}
        </div> 
        
                 

        </div>

        </>
    )

}

export default ThowColumLayoutDashboard